import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const handleHashClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    };

    document.addEventListener('click', handleHashClick);
    return () => document.removeEventListener('click', handleHashClick);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <AboutSection />
        <UpdatesSection />
        <RankingSection />
        <MediaSection />
        <AppSection />
        <FeaturesSection />
        <ContactSection />
        <CommentsSection />
        <FaqSection />
        <CarouselSection />
        <IndexSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}